<template>
  <div class="table-card">
    <div class="ranking-table-wrapper">
      <table @mouseleave="$emit('hover-column', 'default')">
        <thead>
          <tr>
            <th @mouseover="$emit('hover-column', 'tem')">TEM</th>
            <th
              class="municipio-header"
              @mouseover="$emit('hover-column', 'municipio')"
            >
              <div class="municipio-header-content">
                <span>Município</span>

                <div
                  :class="[
                    'header-search',
                    { active: search || searchFocused },
                  ]"
                >
                  <i class="icofont-search"></i>

                  <input
                    :value="search"
                    type="text"
                    placeholder="Buscar..."
                    @focus="searchFocused = true"
                    @blur="searchFocused = false"
                    @input="$emit('change-search', $event.target.value)"
                    @click.stop
                  />

                  <button
                    v-if="search"
                    type="button"
                    @click.stop="$emit('change-search', '')"
                  >
                    <i class="icofont-close"></i>
                  </button>
                </div>
              </div>
            </th>
            <th class="regular" @mouseover="$emit('hover-column', 'regular')">
              Reg
            </th>
            <th
              class="suficiente"
              @mouseover="$emit('hover-column', 'suficiente')"
            >
              Suf
            </th>
            <th class="bom" @mouseover="$emit('hover-column', 'bom')">Bom</th>
            <th class="otimo" @mouseover="$emit('hover-column', 'otimo')">
              Ótimo
            </th>
            <th
              class="desempenho"
              @mouseover="$emit('hover-column', 'desempenho')"
            >
              Componentes
            </th>

            <th
              class="indicadores"
              @mouseover="$emit('hover-column', 'indicadores')"
            >
              Indicadores
            </th>
            <!--
            <th class="ied" @mouseover="$emit('hover-column', 'ied')">IED</th>

            <th class="equipes" @mouseover="$emit('hover-column', 'equipes')">
              Equipes
            </th>

            <th
              class="populacao"
              @mouseover="$emit('hover-column', 'populacao')"
            >
              População
            </th> -->
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in items" :key="item.key">
            <td class="tem-column">
              <a href="https://esusfeedback.com.br/" target="_blank">
                <img
                  v-if="item.tem_esus_feedback == 1"
                  src="@/assets/images/logo-mini.png"
                  alt="Tem eSUS Feedback"
                />

                <img
                  v-else
                  src="@/assets/images/logo-feedback-black.png"
                  alt="Não tem eSUS Feedback"
                />
              </a>
            </td>
            <td>
              <div class="municipio-cell">
                <div class="actions-wrapper">
                  <button
                    class="details-btn"
                    @click.stop="toggleMenu(item.key)"
                  >
                    <i class="icofont-navigation-menu"></i>
                  </button>

                  <div v-if="openedMenuKey === item.key" class="actions-menu">
                    <button @click.stop="abrirDetalhes(item)">
                      <i class="icofont-eye"></i>
                      Detalhes do Ranking
                    </button>

                    <button @click.stop="abrirSimulador(item)">
                      <i class="icofont-calculator"></i>
                      Simulador
                    </button>

                    <button @click.stop="abrirDesempenho(item)">
                      <i class="icofont-award"></i>
                      Desempenho
                    </button>

                    <!-- <button @click.stop="exportarMunicipio(item)">
                      <i class="icofont-download"></i>
                      Exportar
                    </button> -->
                  </div>
                </div>

                <span
                  :class="[
                    'position-badge',
                    getPositionClass(item.posicaoReal),
                  ]"
                >
                  <i
                    v-if="
                      item.posicaoReal === 1 ||
                      item.posicaoReal === 2 ||
                      item.posicaoReal === 3
                    "
                    class="icofont-trophy"
                  ></i>
                  {{ item.posicaoReal }}º
                </span>

                <div class="municipio-info">
                  <div class="municipio-title">
                    {{ item.municipio }}
                    <span class="uf">{{ item.uf }}</span>

                    <router-link
                      v-if="getMelhorRankingLink(item)"
                      :to="getMelhorRankingLink(item).route"
                      class="melhor-ranking-link"
                    >
                      {{ getMelhorRankingLink(item).text }}
                    </router-link>
                  </div>

                  <div class="municipio-meta">
                    <span>
                      IED <strong>{{ item.ied || '-' }}</strong>
                    </span>

                    <span>
                      Equipes
                      <strong>{{ item.totalGeral ?? '' }} </strong>
                    </span>

                    <span>
                      População
                      <strong> {{ formatNumber(item.populacao) }}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </td>

            <td class="regular">
              <span v-if="item.regular">
                {{ formatPercent(item.regular.prcntl_eq_aval) }}
              </span>
            </td>

            <td class="suficiente">
              <span v-if="item.suficiente">
                {{ formatPercent(item.suficiente.prcntl_eq_aval) }}
              </span>
            </td>

            <td class="bom">
              <span v-if="item.bom">
                {{ formatPercent(item.bom.prcntl_eq_aval) }}
              </span>
            </td>

            <td class="otimo">
              <span v-if="item.otimo">
                {{ formatPercent(item.otimo.prcntl_eq_aval) }}
              </span>
            </td>

            <td class="desempenho">
              <strong>{{ item.notaGeral }}</strong>
            </td>

            <td class="indicadores">
              <strong v-if="item.desempenhoIndicadores">
                {{ item.desempenhoIndicadores }}
              </strong>
              <span v-else>-</span>
            </td>

            <!-- <td class="ied">
              <strong>{{ item.ied || '-' }}</strong>
            </td>

            <td class="equipes">
              <strong>{{ item.totalGeral }}</strong>
            </td>

            <td class="populacao">
              <strong v-if="item.populacao">
                {{ formatNumber(item.populacao) }}
              </strong>
              <span v-else>-</span>
            </td> -->
          </tr>

          <tr v-if="!items.length">
            <td colspan="10" class="empty">Nenhum município encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankingTable',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      openedMenuKey: null,
      searchFocused: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.closeMenu)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeMenu)
  },

  methods: {
    /**
     * Retorna os dados do link para o melhor ranking do município.
     *
     * Regras:
     * - G: melhor no geral, desde que a tela atual não seja ranking-geral.
     * - R: melhor no regional, desde que a tela atual não seja ranking-regional.
     * - P: melhor no populacional, desde que a tela atual não seja ranking-porte-populacional.
     * - O ranking deve ser menor que 21.
     *
     * @param {Object} item Município do ranking.
     * @returns {Object|null}
     */
    getMelhorRankingLink(item) {
      const melhorRank = Number(item.melhor_rank)
      const tipoMelhor = String(item.is_melhor || '').toUpperCase()
      const rotaAtual = this.$route.path
      const posicaoRegiaoSaude = Number(item.posicao_regiao_saude ?? 0)

      if (!Number.isFinite(melhorRank) || melhorRank <= 0 || melhorRank >= 21) {
        return null
      }

      const links = {
        G: {
          path: '/cofinanciamento/ranking-geral',
          text: 'Melhor no geral',
        },
        R: {
          path: '/cofinanciamento/ranking-regional',
          text: 'Melhor no regional',
        },
        P: {
          path: '/cofinanciamento/ranking-porte-populacional',
          text: 'Melhor no populacional',
        },
      }

      const link = links[tipoMelhor]

      if (!link || rotaAtual === link.path) {
        return null
      }

      // Melhor no regional só aparece para os 5 primeiros da região
      if (tipoMelhor === 'R' && posicaoRegiaoSaude >= 6) {
        return null
      }

      return {
        text: link.text,
        route: {
          path: link.path,
          // query: {
          //   quadrimestre: item.quadrimestre,
          //   ibge: item.ibge,
          // },
        },
      }
    },

    /**
     * Abre ou fecha o menu de ações da linha.
     *
     * @param {string} key Identificador único da linha.
     * @returns {void}
     */
    toggleMenu(key) {
      this.openedMenuKey = this.openedMenuKey === key ? null : key
    },

    /**
     * Fecha o menu de ações.
     *
     * @returns {void}
     */
    closeMenu() {
      this.openedMenuKey = null
    },

    /**
     * Abre o modal de detalhes do município.
     *
     * @param {Object} item Município selecionado.
     * @returns {void}
     */
    abrirDetalhes(item) {
      this.openedMenuKey = null
      this.$emit('detalhar', item)
    },

    /**
     * Emite evento para exportar os dados do município.
     *
     * @param {Object} item Município selecionado.
     * @returns {void}
     */
    exportarMunicipio(item) {
      this.openedMenuKey = null
      this.$emit('exportar-municipio', item)
    },

    /**
     * Formata o valor percentual.
     *
     * @param {number} value Valor percentual.
     * @returns {string}
     */
    formatPercent(value) {
      if (
        value === 0 ||
        value === null ||
        value === undefined ||
        value === ''
      ) {
        return ''
      }
      return `${Number(value || 0).toFixed(1)}%`
    },

    /**
     * Retorna a classe visual da posição.
     *
     * @param {number} position Posição do município.
     * @returns {string}
     */
    getPositionClass(position) {
      if (position === 1) return 'first'
      if (position === 2) return 'second'
      if (position === 3) return 'third'

      return ''
    },

    /**
     * Formata número inteiro no padrão brasileiro.
     *
     * @param {number|string|null} value Valor numérico.
     * @returns {string}
     */
    formatNumber(value) {
      return Number(value || 0).toLocaleString('pt-BR')
    },

    /**
     * Emite evento para abrir o simulador do município.
     *
     * @param {Object} item Município selecionado.
     * @returns {void}
     */
    abrirSimulador(item) {
      this.openedMenuKey = null
      this.$emit('abrir-simulador', item)
    },

    /**
     * Emite evento para abrir o desempenho do município.
     *
     * @param {Object} item Município selecionado.
     * @returns {void}
     */
    abrirDesempenho(item) {
      this.openedMenuKey = null
      this.$emit('abrir-desempenho', item)
    },
  },
}
</script>

<style scoped>
.table-card {
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  overflow: visible;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.ranking-table-wrapper {
  display: block;
  width: 100%;
  overflow: visible;
}

@media (max-width: 768px) {
  .ranking-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
}

thead {
  position: sticky;
  top: -3%;
  z-index: 80;
}

thead tr {
  background: #f3f4f6;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

th {
  background: #f3f4f6;
  color: #374151;
  text-transform: uppercase;
  font-size: 12px;
  padding: 16px;
  text-align: left;
}

td {
  padding: 14px 16px;
  border-top: 1px solid #dfe6ee;
}

tbody tr:hover {
  background: #eff6ff;
}

th:not(:first-child),
td:not(:first-child) {
  text-align: center;
}

.municipio-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
}

.municipio-header {
  min-width: 520px;
  width: 520px;
  z-index: 60;
}

.municipio-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.header-search {
  position: relative;
  width: 80px;
  height: 34px;
}

.header-search input {
  width: 100%;
  height: 34px;
}

.header-search.active,
.header-search:focus-within {
  width: 260px;
}

.header-search i {
  position: absolute;
  top: 50%;
  left: 11px;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 13px;
  z-index: 2;
}

.header-search i.icofont-close {
  left: -10px;
}

.header-search input {
  width: 100%;
  height: 34px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #ffffff;
  padding: 0 32px;
  font-size: 12px;
  outline: none;
}

.header-search input::placeholder {
  color: transparent;
}

.header-search.active input,
.header-search:focus-within input {
  border-radius: 10px;
  border-color: #60a5fa;
  box-shadow: 0 0 0 4px #eff6ff;
  cursor: text;
}

.header-search.active input::placeholder,
.header-search:focus-within input::placeholder {
  color: #9ca3af;
}

.header-search button {
  position: absolute;
  top: 50%;
  right: 9px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  z-index: 3;
}

.header-search button:hover {
  color: #ef4444;
}

.details-btn {
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 999px;
}

.details-btn:hover {
  background: #dbeafe;
  color: #2563eb;
}

.position-badge {
  color: #4338ca;
  font-weight: 900;
}

.position-badge.first {
  background: #facc15;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 999px;
}

.position-badge.second {
  background: #c2cad6;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 999px;
}

.position-badge.third {
  background: #b45309;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 999px;
}

.regular {
  /* background: #fff7ed; */
  color: #c2410c;
  font-weight: 800;
}

.suficiente {
  /* background: #fefce8; */
  color: #a16207;
  font-weight: 800;
}

.bom {
  /* background: #f0fdf4; */
  color: #15803d;
  font-weight: 800;
}

.otimo {
  /* background: #eff6ff; */
  color: #1d4ed8;
  font-weight: 800;
}

.desempenho {
  /* background: #eef2ff; */
  color: #6b7280;
}

.desempenho strong {
  font-size: 20px;
  color: #000;
}

.empty {
  text-align: center;
  color: #6b7280;
  padding: 24px;
}

.actions-wrapper {
  position: relative;
  display: inline-flex;
}

.actions-menu {
  position: absolute;
  top: 36px;
  left: 0;
  width: 180px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.16);
  z-index: 20;
  overflow: hidden;
}

.actions-menu button {
  width: 100%;
  border: none;
  background: #ffffff;
  padding: 11px 14px;
  text-align: left;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.actions-menu button:hover {
  background: #eff6ff;
  color: #2563eb;
}

.tem-column img {
  width: 38px;
  height: auto;
}

thead th:hover {
  cursor: pointer;
  background: #dbeafe;
  color: #1d4ed8;
}

tbody td:hover {
  filter: brightness(0.96);
}

.equipes {
  background: #f8fafc;
  color: #475569;
  border-left: 1px solid #f3e8ff;
}

.indicadores {
  /* background: #eef2ff; */
  color: #475569;
  border-left: 1px solid #f3e8ff;
}

.ied {
  background: #f8fafc;
  color: #475569;
  font-weight: 800;
  border-left: 1px solid #e2e8f0;
}

.populacao {
  background: #f8fafc;
  color: #4b5563;
  font-weight: 800;
  border-left: 1px solid #e2e8f0;
}

.municipio-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.municipio-title {
  font-size: 16px;
  font-weight: 700;
  color: rgb(15, 23, 42);
  text-transform: uppercase;
}

.municipio-title .uf {
  margin-left: 4px;
  font-size: 12px;
  font-weight: 700;
  color: rgb(100, 116, 139);
}

.municipio-meta {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  font-size: 11px;
  color: rgb(148, 163, 184);
}

.municipio-meta strong {
  font-weight: 700;
  color: rgb(100, 116, 139);
}

.melhor-ranking-link {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 700;
  color: #2563eb;
  text-transform: none;
  text-decoration: none;
  white-space: nowrap;
}

.melhor-ranking-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
</style>
